import { render } from "./SpecForm.vue?vue&type=template&id=3382e944&scoped=true&ts=true"
import script from "./SpecForm.vue?vue&type=script&lang=ts"
export * from "./SpecForm.vue?vue&type=script&lang=ts"

import "./SpecForm.vue?vue&type=style&index=0&id=3382e944&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3382e944"]])

export default __exports__